import { fetchDeviceData } from "../../utils/fetchDeviceData";

export const apiFetch = async (url, options = {}) => {

    let accessToken = localStorage.getItem("accessToken");
    const isFormData = options.body instanceof FormData;

    const headers = {
        ...(options.headers || {}),
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        Authorization: accessToken ? `Bearer ${accessToken}` : "",
    };

    let response = await fetch(url, {
        ...options,
        headers,
        credentials: "include",
    })

    const cloned = response.clone();
    const tempResponse = await cloned.json().catch(() => ({}));

    if (tempResponse.requiredAccessToken) {
        try {

            const deviceDetails = await fetchDeviceData()

            const fingerPrintId = deviceDetails.fingerPrintId || ""
            const browserName = deviceDetails.browserName || ""
            const ipAddress = deviceDetails.ipAddress || ""

            const refreshRes = await fetch(`${process.env.REACT_APP_BeURL}/refresh`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json", 
                    Accept: "application/json"
                },
                body: JSON.stringify({ fingerPrintId, browserName, ipAddress })
            });

            const data = await refreshRes.json();

            if (data.success) {

                accessToken = data.accessToken;

                localStorage.setItem("accessToken", accessToken);

                const retryHeaders = {
                    ...(options.headers || {}),
                    ...(isFormData ? {} : { "Content-Type": "application/json" }),
                    Authorization: `Bearer ${accessToken}`,
                };

                const retryResponse = await fetch(url, {
                    ...options,
                    headers: retryHeaders,
                    credentials: "include",
                });

                return retryResponse
            } else {
                console.error("Refresh token invalid/expired");
                localStorage.removeItem("accessToken");
                // window.location.href = "/signin";

                return {
                    ok: false,
                    json: async () => ({
                        success: false,
                        message: "Invalid or expired refresh token!",
                    }),
                }
            }
        }
        catch (err) {
            console.log("Error in refresh token api:", err)
            return {
                ok: false,
                json: async () => ({
                    success: false,
                    message: "Invalid or expired refresh token!",
                }),
            }
        }
    }
    return response;
};
